import { nonBusinessEventTracker } from "@/handle/event/nonBussiness";
import { setRequestCache } from "../cache";
import { isUndefined } from "__barrel_optimize__?names=isUndefined!=!lodash-es";
const ERRORCODE_MAP_MESSAGE = {
  "100000": "user not exists",
  "100001": "User already exist",
  "100018": "Email has not registered",
  "100013": "Wrong verification code",
  "100012": "Wrong verification code"
};
const resErrorCodeHandle = response => {
  const {
    data
  } = response;
  if (!data) {
    // 空响应体不做处理
    return;
  }
  if (data.code === 100007) {
    // 未登录时情况当前登录信息
    // useUserCreate.getState().dispatch({ type: 'clearUserInfo', payload: {} });
  }
  const error = new Error(data.msg, {
    cause: {
      code: data.code,
      message: ERRORCODE_MAP_MESSAGE[data.code]
    }
  });
  return error;
};
/**
 * 请求成功拦截
 */
export const resFulfillIntcpt = response => {
  const {
    status,
    data,
    config
  } = response;
  // TODO: 兼容移动端（待移除）
  const res = response.data;
  switch (status) {
    case 200:
    case 201:
      {
        if (data.code !== 0) {
          resErrorCodeHandle(response);
        }
        if (data.code === 0 && (config === null || config === void 0 ? void 0 : config.cache)) {
          const {
            url = "",
            params
          } = response.config;
          setRequestCache({
            url: url,
            data: params
          }, res);
        }
        if (data.code === 0) nonBusinessEventTracker(response);
        return res;
      }
  }
  if (!data) throw new Error("response is empty");
  if (isUndefined(data.code) || data.code === 0) {
    return res;
  }
  throw resErrorCodeHandle(response);
};
/**
 * 请求失败拦截
 */
export const resRejectIntcpt = error => {
  const response = error.response;
  return Promise.reject(response);
};